import { HeaderInlineTitleContainer, HeaderInlineTitleTextContainer, HeaderTextContainer, ModalCloseButtonContainer, ModalInlineCloseButtonContainer } from '../styles';
import { StackChildren, Text } from '@doordash/design-language';
import CloseButton from './CloseButton';
import { CloseButtonSides } from '../constants';
import HeaderText from './HeaderText';
import ModalHeaderImage from './ModalHeaderImage';
import PropTypes from 'prop-types';
import React from 'react';

var DefaultContentHeader = function DefaultContentHeader(_ref) {
  var closeButtonAccessibilityLabel = _ref.closeButtonAccessibilityLabel,
      closeButtonSide = _ref.closeButtonSide,
      headerAlignment = _ref.headerAlignment,
      headerImage = _ref.headerImage,
      hasCloseButton = _ref.hasCloseButton,
      hasContent = _ref.hasContent,
      hasPadding = _ref.hasPadding,
      modalPadding = _ref.modalPadding,
      onClose = _ref.onClose,
      subtitle = _ref.subtitle,
      subtitleSize = _ref.subtitleSize,
      title = _ref.title,
      titleSize = _ref.titleSize;
  var displayCloseButton = !headerImage && hasCloseButton;

  if (closeButtonSide === CloseButtonSides.Trailing) {
    return React.createElement(React.Fragment, null, headerImage && React.createElement(ModalHeaderImage, {
      headerImage: headerImage
    }), React.createElement(HeaderInlineTitleContainer, {
      hasCloseButton: displayCloseButton,
      hasPadding: hasPadding,
      isCenterAligned: headerAlignment === Text.TextAlignments.Center,
      modalPadding: modalPadding,
      hasHeaderImage: !!headerImage
    }, React.createElement(HeaderInlineTitleTextContainer, {
      size: hasPadding ? StackChildren.Sizes.XxSmall : StackChildren.Sizes.None
    }, React.createElement(HeaderText, {
      headerAlignment: headerAlignment,
      title: title,
      subtitle: subtitle,
      titleSize: titleSize,
      subtitleSize: subtitleSize
    })), displayCloseButton && React.createElement(ModalInlineCloseButtonContainer, {
      modalPadding: modalPadding
    }, React.createElement(CloseButton, {
      closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
      onClose: onClose
    }))));
  }

  return React.createElement(React.Fragment, null, displayCloseButton && React.createElement(ModalCloseButtonContainer, {
    closeButtonSide: closeButtonSide,
    modalPadding: modalPadding
  }, React.createElement(CloseButton, {
    closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
    onClose: onClose
  })), headerImage && React.createElement(ModalHeaderImage, {
    headerImage: headerImage
  }), React.createElement(HeaderTextContainer, {
    hasCloseButton: hasCloseButton,
    hasContent: hasContent,
    hasHeaderImage: !!headerImage,
    hasContentPadding: hasPadding,
    modalPadding: hasPadding ? modalPadding : 0
  }, React.createElement(StackChildren, {
    size: hasPadding ? StackChildren.Sizes.XxSmall : StackChildren.Sizes.None
  }, React.createElement(HeaderText, {
    headerAlignment: headerAlignment,
    title: title,
    subtitle: subtitle,
    titleSize: titleSize,
    subtitleSize: subtitleSize
  }))));
};

DefaultContentHeader.propTypes = {
  closeButtonAccessibilityLabel: PropTypes.string,
  closeButtonSide: PropTypes.string,
  onClose: PropTypes.func,
  headerAlignment: PropTypes.oneOf([Text.TextAlignments.Left, Text.TextAlignments.Center]).isRequired,
  headerImage: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.string,
  titleSize: PropTypes.number,
  subtitleSize: PropTypes.number,
  hasCloseButton: PropTypes.bool.isRequired,
  hasContent: PropTypes.bool.isRequired,
  hasPadding: PropTypes.bool,
  titleId: PropTypes.string.isRequired,
  subtitleId: PropTypes.string,
  modalPadding: PropTypes.number
};
export default DefaultContentHeader;